import type { LucideIcon } from "lucide-react";
import { Construction, LockKeyhole } from "lucide-react";

import { Badge } from "../components/ui/badge";

interface PlaceholderPageProps {
  description: string;
  icon: LucideIcon;
  title: string;
}

export function PlaceholderPage({
  description,
  icon: Icon,
  title,
}: PlaceholderPageProps) {
  return (
    <div className="animate-rise">
      <Badge tone="neutral">
        <Construction aria-hidden="true" className="size-3" />
        Foundation placeholder
      </Badge>
      <h1 className="mt-4 text-3xl font-black tracking-[-0.05em] text-ink sm:text-4xl">
        {title}
      </h1>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-ink-soft sm:text-base">
        {description}
      </p>

      <section className="mt-10 grid min-h-[26rem] place-items-center rounded-3xl border border-dashed border-line bg-surface/65 p-8 text-center">
        <div className="max-w-sm">
          <span className="mx-auto grid size-14 place-items-center rounded-2xl bg-surface-muted text-ink-soft">
            <Icon aria-hidden="true" className="size-5" />
          </span>
          <h2 className="mt-5 text-lg font-extrabold tracking-[-0.025em] text-ink">
            Not enabled in the foundation build
          </h2>
          <p className="mt-2 text-sm leading-6 text-ink-soft">
            This area stays intentionally empty until authentication, organization
            membership, and accounting-entity isolation are in place.
          </p>
          <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-positive">
            <LockKeyhole aria-hidden="true" className="size-3.5" />
            Closed by design
          </span>
        </div>
      </section>
    </div>
  );
}
